
(function(){
  var SKIP={SCRIPT:1,STYLE:1,NOSCRIPT:1,TEXTAREA:1,'MODEL-VIEWER':1,SVG:1,CODE:1};
  var BLOCK={P:1,H1:1,H2:1,H3:1,H4:1,H5:1,H6:1,LI:1,DIV:1,SECTION:1,ARTICLE:1,BUTTON:1,TD:1,TH:1,SUMMARY:1,FIGCAPTION:1,LABEL:1,DETAILS:1,FOOTER:1,HEADER:1,NAV:1,ASIDE:1,MAIN:1,UL:1,OL:1};
  function wordAt(s,i){var m=s.slice(i).match(/^[^\s]+/);return m?m[0]:''}
  function isUrlish(w){return w.indexOf('@')!==-1||/\.[a-z]{2,4}(\/|$)/i.test(w)}
  function fixNode(t,state){
    var s=t.nodeValue,out='',changed=false,cap=state.cap;
    for(var i=0;i<s.length;i++){
      var ch=s[i];
      if(cap&&ch>='a'&&ch<='z'){
        if(isUrlish(wordAt(s,i))){out+=ch;cap=false}
        else{out+=ch.toUpperCase();changed=true;cap=false}
      }else{
        out+=ch;
        if(/[A-Za-z0-9]/.test(ch))cap=false;
        if(ch==='.'||ch==='!'||ch==='?')cap=true;
      }
    }
    state.cap=cap;
    if(changed)t.nodeValue=out;
  }
  var applying=false;
  function walk(root){
    applying=true;
    try{
      var stack=[[root,{cap:true}]];
      function rec(el,state){
        if(el.nodeType===3){fixNode(el,state);return}
        if(el.nodeType!==1)return;
        var tag=el.tagName;
        if(SKIP[tag]||el.hasAttribute&&el.hasAttribute('data-nocase'))return;
        var unit=BLOCK[tag];
        if(tag==='A'){
          var ps=el.previousSibling;
          var midSentence=ps&&ps.nodeType===3&&/\S/.test(ps.nodeValue)&&!/[.!?]\s*$/.test(ps.nodeValue);
          if(!midSentence)unit=true;
        }
        var st=unit?{cap:true}:state;
        for(var c=el.firstChild;c;c=c.nextSibling)rec(c,st);
      }
      rec(root,{cap:true});
    }finally{applying=false}
  }
  function boot(){
    walk(document.body);
    var mo=new MutationObserver(function(muts){
      if(applying)return;
      muts.forEach(function(m){
        if(m.type==='characterData'&&m.target.parentNode){applying=true;try{fixNode(m.target,{cap:true})}finally{applying=false}}
        m.addedNodes&&m.addedNodes.forEach(function(n){
          if(n.nodeType===1)walk(n);
          else if(n.nodeType===3){applying=true;try{fixNode(n,{cap:true})}finally{applying=false}}
        });
      });
    });
    mo.observe(document.body,{childList:true,subtree:true,characterData:true});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);
  else boot();
})();
